import { Text } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import Link from 'modules/UI/components/Link';

export const NotificationText = styled(Text)`
  display: block;
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.xs};
  color: ${tokens.colors.white};
  font-weight: bold;
  white-space: pre-wrap;
  line-height: ${tokens.lineHeights.s};
`;

export const NotificationLink = styled(Link).attrs({ noStyles: true })`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.xs};
  font-weight: bold;
  color: ${tokens.colors.white};
  text-decoration: underline;
`;
